import { ResourceLanguage } from "i18next";
import mapKeys from "lodash/mapKeys";

export enum LanguageResourceKey {
  en = "en",
  frCA = "fr-CA",
  frFR = "fr-FR",
  esES = "es-ES",
  noNO = "no-NO",
  ptPT = "pt-PT",
  svSE = "sv-SE",
  deDE = "de-DE",
  fiFI = "fi-FI",
  daDK = "da-DK",
  jaJP = "ja-JP"
}

const getFileName = (path: string) =>
  path
    .split("/")
    .pop()
    ?.replace(/\.[^/.]+$/, "");

const en = mapKeys(import.meta.glob("../../../../config/i18n/en/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const frCA = mapKeys(import.meta.glob("../../../../config/i18n/frCA/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const frFR = mapKeys(import.meta.glob("../../../../config/i18n/frFR/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const esES = mapKeys(import.meta.glob("../../../../config/i18n/esES/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const noNO = mapKeys(import.meta.glob("../../../../config/i18n/noNO/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const ptPT = mapKeys(import.meta.glob("../../../../config/i18n/ptPT/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const svSE = mapKeys(import.meta.glob("../../../../config/i18n/svSE/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const deDE = mapKeys(import.meta.glob("../../../../config/i18n/deDE/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const fiFI = mapKeys(import.meta.glob("../../../../config/i18n/fiFI/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const daDK = mapKeys(import.meta.glob("../../../../config/i18n/daDK/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

const jaJP = mapKeys(import.meta.glob("../../../../config/i18n/jaJP/*.json", { eager: true }), (_, path) =>
  getFileName(path)
) as ResourceLanguage;

export const resources = {
  [LanguageResourceKey.en]: en,
  [LanguageResourceKey.frCA]: frCA,
  [LanguageResourceKey.frFR]: frFR,
  [LanguageResourceKey.esES]: esES,
  [LanguageResourceKey.noNO]: noNO,
  [LanguageResourceKey.ptPT]: ptPT,
  [LanguageResourceKey.svSE]: svSE,
  [LanguageResourceKey.deDE]: deDE,
  [LanguageResourceKey.fiFI]: fiFI,
  [LanguageResourceKey.daDK]: daDK,
  [LanguageResourceKey.jaJP]: jaJP
};
